import { HostingModel, ServerModel } from '@/models'
import { ProductViewModel } from '@/view-models'
import { CartModalManager } from './cart-modal.manager'
import { FeaturesView } from './features.view'
import { ProductButtonView } from './product-button.view'

export class PricingPlanView {
  private widget: HTMLElement

  constructor(
    model: HostingModel | ServerModel,
    widget: HTMLElement,
    modalManager: CartModalManager,
    productViewModel: ProductViewModel
  ) {
    this.widget = widget

    const productFeatures = this.widget.querySelector<HTMLElement>(
      '.js-product-list-modal .js-product-features'
    )

    if (!productFeatures) {
      throw new Error('Pricing Plan View: feature List is missing')
    }

    new FeaturesView(productFeatures)
    new ProductButtonView(model, this.widget, modalManager, productViewModel)
  }

  toggleVisibility(): void {
    this.widget.classList.toggle('pricing--open')
  }
}
